import { AddRequestAnswers } from "components/ChatCard/RequestAnswers/AddRequestAnswers";
import { Button } from "components/DesignSystem/Button/Button";
import { useModal } from "hooks/useModal";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";

export const RequestAnswerCTA = ({
  customData,
  groupId,
}: {
  customData: CustomData;
  groupId: string;
}) => {
  const { answer_request_id, requested_answers } = customData.metadata || {};
  const viewAnswers = useModal();

  const isAllQuestionAnswered = requested_answers?.every(
    (question) => question.is_answered
  );

  return (
    <div>
      <Button block size="small" onClick={viewAnswers.open}>
        {isAllQuestionAnswered ? "View" : "Add"}
      </Button>
      {viewAnswers.isOpen && (
        <AddRequestAnswers
          {...viewAnswers}
          requestId={answer_request_id!}
          groupId={groupId}
        />
      )}
    </div>
  );
};
